import * as React from "react";
import { styled } from "@mui/system";
import MUIDialog from "@mui/material/Dialog";
import { DialogProps } from "@mui/material/Dialog";

export const Dialog: (props: DialogProps) => JSX.Element = styled(
  React.forwardRef<HTMLDivElement, DialogProps>((props, ref) => (
    <MUIDialog ref={ref} {...props} />
  )),
  {
    name: "Dialog",
    slot: "Root",
    overridesResolver: (props, styles) => []
  }
)(({ theme }) => ({
  "&.MuiDialog-root .MuiDialog-container	.MuiDialog-paper": {
    boxShadow: theme.shadows[6]
  }
}));
